/**
 * Picks the fields the attribution survey must echo back — WEBDEV-4079 Part E.
 *
 * The handler returns these only when LEADS_CAPTURE_ENABLED is on, so this yields an empty
 * object on the Pardot path and the client stays flag-agnostic. Echoing the same submissionId
 * is what makes the survey an update to the original lead rather than a second record.
 */
export const getLeadsCaptureEcho = (response) => {
    const { submissionId, tu_individual_id, tu_household_id, salesforceId } = response?.data ?? {};
    if (!submissionId) return {};

    // salesforceId is echoed so the handler can verify the survey's answer landed on this same
    // record — alreadyExists alone cannot, since Salesforce also returns it for an email match.
    return { submissionId, tu_individual_id, tu_household_id, salesforceId };
};
